module.exports = __webpack_public_path__ + "img/apple-touch-icon.8d9bfddc.png";